import React from 'react';
import Button from '@mui/material/Button';
import { exportLatencyData } from 'services/latency/exportLatencyData';
import { LatencyMeasurePoint } from 'core/models/latency';
import { SafeBox } from 'components/views/atoms/SafeBox';

export type LatencyButtonProps = {
    points: LatencyMeasurePoint;
    addPoint: () => void;
    clearPoints: () => void;
}

export const LatencyButton = (props: LatencyButtonProps) => {
    const { points, addPoint, clearPoints } = props;

    const onSaveClick = () => {
        exportLatencyData(points);
    };

    return (
        <SafeBox sx={{
            '& > *': {
                margin: theme => theme.spacing(1),
                backgroundColor: theme => theme.palette.common.black,
                color: theme => theme.palette.common.white,
            },
        }}>
            <Button variant='contained' onClick={clearPoints}>
                Reset
            </Button>
            <Button variant='contained' onClick={addPoint}>
                Mark point
            </Button>
            <Button variant='contained' onClick={onSaveClick}>
                Save
            </Button>
        </SafeBox>
    );
};
